import React, {useState, useEffect,useContext} from 'react';
import { RootStoreContext } from '../stores/RootStore';
import DashboardGraphic from "../features/DashboardGraphic";
import DashboardTable from "../features/DashboardTable";
import DashboardTable2 from "../features/DashboardTable2";


const DashboardPage = (prop:any) => {

    const levelVal  =  window.localStorage.getItem('levelid');
    const emplidVal =  window.localStorage.getItem('emplid'); 
    const rootStore = useContext(RootStoreContext);
    const { dashboard} = rootStore.commonStore; 

    const [list, setList] = useState<any>() 
    const [semester, setSemester] = useState("")
    const [statusDashboard1, setStatusDashboard1] = useState(false)  
    const [statusDashboard2, setStatusDashboard2] = useState(false)  
    const [program, setProgram] = useState<any>() 
    const [bgColor, setBgColor] = useState<any>() 
    const [wl1, setWl1] = useState<any>() 
    const [wl2, setWl2] = useState<any>() 
    const [wl3, setWl3] = useState<any>() 

    useEffect(() => {

        const data = dashboard(String(levelVal), String(emplidVal));
        data.then(function(result) {
            setList(result.report)
            setSemester(result.semester)
            if(levelVal!="2")
            {
                setProgram(result.program)
                setBgColor(result.bgcolor)
                setWl1(result.wl1)
                setWl2(result.wl2)
                setWl3(result.wl3)
                if(result.semester!="")
                    setStatusDashboard1(true)
            }
            else
            {
                setStatusDashboard2(true)
            }
            
        })

    },[])

    return (
        <React.Fragment>
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Dashboard</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Warning Letter : {semester}</h3>
                                </div>
                                {
                                    statusDashboard1 ? 
                                    <> 
                                        <DashboardGraphic program={program} bgColor={bgColor} wl1={wl1} wl2={wl2} wl3={wl3}/> 
                                        <DashboardTable data={list}/>
                                    </> 
                                    : <> </> 
                                }

                                {
                                    statusDashboard2 ? 
                                    <> 
                                        <DashboardTable2 data={list}/>
                                    </> 
                                    : <> </> 
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        </React.Fragment>
    );
}

export default DashboardPage;